import React, { useEffect, useState } from "react";
import DashboardCard from "../../components/DashboardCard/DashboardCard";
import "./Dashboard.scss";
import ToastHelper from "../../services/ToastHelper";
import { GET_DASHBOARD_DATA } from "../../utils/apiPath";
import { getApi } from "../../utils/apiServices";

const cards = [
  {
    bg: "#F8EFFF",
    heading: "Completed Orders",
    value: 1211,
    percentage: "100%",
  },
  {
    bg: "#FFF7E4",
    heading: "Pending Orders",
    value: 1211,
    percentage: "100%",
  },
  {
    bg: "#E3F5FF",
    heading: "Total Products Count",
    value: 1211,
    percentage: "100%",
  },
  {
    bg: "#FFE8EB",
    heading: "Total Categories Count",
    value: 1211,
    percentage: "100%",
  },
  {
    bg: "#E6EEFF",
    heading: "New Users",
    value: 342,
    percentage: "10% increase",
  },
  {
    bg: "#FFEFD5",
    heading: "Total Revenue",
    value: "$34,000",
    percentage: "15% increase",
  },
  {
    bg: "#FFE4E1",
    heading: "Refund Requests",
    value: 23,
    percentage: "2% decrease",
  },
  {
    bg: "#FFFACD",
    heading: "Low Stock Products",
    value: 57,
    percentage: "Restock needed",
  },
  {
    bg: "#E0FFFF",
    heading: "Site Traffic",
    value: 5123,
    percentage: "8% increase",
  },
];

const Dashboard = () => {
  const [dashBoardData, setDashBoardData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  function convertToArray(dataObj) {
    const result = [];
    let index = 0;

    for (const key in dataObj) {
      if (key.endsWith("Percentage")) continue;

      const percentageKey = key + "Percentage";

      const cardMeta = cards[index] || {};

      result.push({
        bg: cardMeta.bg,
        heading: key,
        value: dataObj[key],
        percentage: dataObj[percentageKey] ?? 0,
      });
      index++;
    }

    return result;
  }

  const getCategoryData = async () => {
    try {
      const res = await getApi(`${GET_DASHBOARD_DATA}`);

      if (res?.statusCode === 200) {
        const result = convertToArray(res?.data);
        console.log(result);
        setDashBoardData(result);
        ToastHelper.success("success");
      } else {
        ToastHelper.error("Something went wrong. Please try again.");
      }
    } catch (err) {
      ToastHelper.error(
        "Failed to connect to the server. Please try again later."
      );
    } finally {
      setIsLoading(false);
    }
    return null;
  };

  useEffect(() => {
    getCategoryData();
  }, []);

  return (
    <div className="dashboard">
      <div className="dashboard_section">
        <div className="dashboard_section_cards">
          {dashBoardData?.length > 0 &&
            dashBoardData?.map((card, index) => {
              return <DashboardCard card={card} key={index} />;
            })}
        </div>
      </div>
    </div>
  );
};

export default Dashboard;
